import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './app';
import { DOM_IDS } from './config';

// Legacy static styles/scripts for visual parity
import '/public/assets/bootstrap/css/bootstrap.min.css';
import '/public/assets/css/Navbar-Right-Links-icons.css';
import '/public/assets/css/styles.css';
import '/public/assets/bootstrap/js/bootstrap.min.js';

// Tokens/themes (can override legacy where needed)
import './styles/global.css';
import './styles/game-content.css';
import './styles/themes/light.css';
import './styles/themes/dark.css';

const container = document.getElementById(DOM_IDS.ROOT);

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
}
